export type DrawLiveLatLng = {
  lat: number;
  lng: number;
};

const isFiniteLatLng = (value: unknown): value is DrawLiveLatLng => {
  if (!value || typeof value !== "object") return false;
  const point = value as DrawLiveLatLng;
  return Number.isFinite(point.lat) && Number.isFinite(point.lng);
};

/**
 * Produces the temporary three-point segment used only while a custom draw
 * midpoint is being dragged. The caller owns rendering and must remove it at
 * drag end; this helper never changes accepted drawing vertices or persistence.
 */
export function buildLiveDrawSegment(
  start: unknown,
  pointer: unknown,
  end: unknown,
): DrawLiveLatLng[] | null {
  if (!isFiniteLatLng(start) || !isFiniteLatLng(pointer) || !isFiniteLatLng(end)) {
    return null;
  }

  return [
    { lat: start.lat, lng: start.lng },
    { lat: pointer.lat, lng: pointer.lng },
    { lat: end.lat, lng: end.lng },
  ];
}

export function isLiveDrawSegmentPoint(
  segment: DrawLiveLatLng[] | null,
  pointer: unknown,
): boolean {
  if (!segment || segment.length !== 3 || !isFiniteLatLng(pointer)) return false;
  const middle = segment[1];
  return middle.lat === pointer.lat && middle.lng === pointer.lng;
}
